import Hero from "../../../../src/components/project/hero";
import GetStarted from "../../../../src/components/project/get-started";
import * as React from 'react';
export default {
  Hero,
  GetStarted,
  React
};